import React from 'react'
import { useNavigate } from 'react-router-dom'
const AuthContext = React.createContext();
const { Provider } = AuthContext;

const AuthProvider = ({ children }) => {
    const history = useNavigate()

    const token = localStorage.getItem('token')
    const userInfo = localStorage.getItem('userInfo')
    const expiresAt = localStorage.getItem('expiresAt')
    const mail = localStorage.getItem('mail')
    const statuses = localStorage.getItem('statuses')
    const impersonation = localStorage.getItem('impersonation')

    const [authState, setAuthState] = React.useState({
        token,
        expiresAt,
        userInfo: userInfo ? JSON.parse(userInfo) : {},
        statuses: statuses ? JSON.parse(statuses) : {},
        impersonation: impersonation ? JSON.parse(impersonation) : null,
    })

    const setMailInfo = ({ mail }) => {
        localStorage.setItem('mail', mail); // без JSON.stringify
        setMailState({ mail })
    }

    const [mailState, setMailState] = React.useState({
        mail: mail || ''  // без JSON.parse
    })

    const setAuthInfo = ({ token, userInfo, expiresAt, statuses }) => {
        localStorage.setItem('token', token);
        localStorage.setItem('userInfo', JSON.stringify(userInfo))
        localStorage.setItem('expiresAt', expiresAt)
        localStorage.setItem('statuses', JSON.stringify(statuses || {})) // добавить
        localStorage.removeItem('impersonation')
        setAuthState({ token, userInfo, expiresAt, statuses: statuses || {}, impersonation: null })
    };

    const startImpersonation = ({ token, userInfo, expiresAt, statuses, impersonation }) => {
        const adminSession = {
            token: authState.token,
            userInfo: authState.userInfo,
            expiresAt: authState.expiresAt,
            statuses: authState.statuses || {},
        }

        sessionStorage.setItem('adminSession', JSON.stringify(adminSession))
        localStorage.setItem('token', token)
        localStorage.setItem('userInfo', JSON.stringify(userInfo))
        localStorage.setItem('expiresAt', expiresAt)
        localStorage.setItem('statuses', JSON.stringify(statuses || {}))
        localStorage.setItem('impersonation', JSON.stringify(impersonation || null))
        setAuthState({ token, userInfo, expiresAt, statuses: statuses || {}, impersonation: impersonation || null })
    }

    const stopImpersonation = () => {
        const adminSession = sessionStorage.getItem('adminSession')

        if (!adminSession) {
            logout()
            return
        }

        const restored = JSON.parse(adminSession)

        localStorage.setItem('token', restored.token)
        localStorage.setItem('userInfo', JSON.stringify(restored.userInfo))
        localStorage.setItem('expiresAt', restored.expiresAt)
        localStorage.setItem('statuses', JSON.stringify(restored.statuses || {}))
        localStorage.removeItem('impersonation')
        sessionStorage.removeItem('adminSession')
        setAuthState({ ...restored, impersonation: null })
        history('/admin-page')
    }

    const hasStatus = (statusId) => {
        const statuses = authState.statuses || {};
        return Object.values(statuses).some(arr => arr.includes(statusId));
    };

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('userInfo');
        localStorage.removeItem('expiresAt');
        localStorage.removeItem('statuses');
        localStorage.removeItem('impersonation');
        sessionStorage.removeItem('adminSession');
        setAuthState({
            token: null,
            expiresAt: null,
            userInfo: null,
            statuses: {},
            impersonation: null,
        });
        history('/login');
    };

    const isAuthenticated = () => {
        if (!authState.token && !authState.expiresAt) {
            return false;
        }
        return (
            new Date().getTime() / 1000 < authState.expiresAt
        );
    };

    const isAdmin = () => {
        if (authState.userInfo.role) {
            return authState.userInfo.role === 'admin';
        } else {
            return authState.userInfo.dataValues.role === 'admin'
        }
    };

    const hasCourtDocs = () => {
        if (!authState.userInfo) return false;
        // userInfo может быть плоским (authorize) или с dataValues (login)
        const info = authState.userInfo.dataValues || authState.userInfo;
        return info.hasCourtDocs === true;
    };

    return (
        <Provider
            value={{
                authState,
                mailState,
                setAuthState: authInfo => setAuthInfo(authInfo),
                setMailState: mailInfo => setMailInfo(mailInfo),
                isAuthenticated,
                logout,
                startImpersonation,
                stopImpersonation,
                isAdmin,
                hasCourtDocs,
                hasStatus 
            }}
        >
            {children}
        </Provider>
    );
};

export { AuthContext, AuthProvider }
